import React from 'react';
import ProgressiveImage from "react-progressive-graceful-image";

import './progressive-img-style.scss';

const ProgressiveImg = ({ originImg, placeholder, alt }) => {
  return (
    <ProgressiveImage src={originImg} placeholder={placeholder}>
      {(src, loading) => (
        <img
          className={`progressive-image${loading ? " loading" : " loaded"}`}
          src={src}
          alt={alt || ''}
          width="100%"
          height="100%"
        />
      )}
    </ProgressiveImage>
  );
}

export default ProgressiveImg;
